import { Navigate } from 'react-router-dom';
import UserHelper from 'general/helpers/UserHelper';
import { useState, useEffect } from 'react';

function PrivateRoute({ children }) {
  const [isAuth, setIsAuth] = useState(null);

  useEffect(() => {
    UserHelper.checkAcountAndPassword().then((res) => {
      setIsAuth(res);
    });
  }, []);

  if (isAuth === null) {
    // The check is still ongoing, you might want to render a loading spinner here
    return null;
  }

  return isAuth ? children : <Navigate to="/signin" />;
}

export default PrivateRoute;

export function LoginRoute() {
  const [isAuth, setIsAuth] = useState(null);

  useEffect(() => {
    UserHelper.checkAcountAndPassword().then((res) => {
      setIsAuth(res);
    });
  }, []);

  if (isAuth === null) {
    // The check is still ongoing, you might want to render a loading spinner here
    return null;
  }

  return isAuth ? <Navigate to="/LichViet" /> : <Navigate to="/signin" />;
}